import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { executeCrmChatAction } from './chatAction.api';
import { CrmChatActionRequest, CrmChatActionResponse } from './chatAction.types';

export const useExecuteCrmChatAction = () =>
  useMutation<CrmChatActionResponse, AxiosError<{ error?: string }>, CrmChatActionRequest>({
    mutationFn: executeCrmChatAction
  });
